export var SIZES = ["XXSMALL", "XSMALL", "SMALL", "MEDIUM", "LARGE", "XLARGE", "2XLARGE", "3XLARGE"];
export var sizeLabelMap = new Map([
    [SIZES[0], "XXS"],
    [SIZES[1], "XS"],
    [SIZES[2], "S"],
    [SIZES[3], "M"],
    [SIZES[4], "L"],
    [SIZES[5], "XL"],
    [SIZES[6], "2XL"],
    [SIZES[7], "3XL"],
]);
export function getSizeText(size) {
    var _a;
    if (!size) {
        return "";
    }
    return (_a = sizeLabelMap.get(size)) !== null && _a !== void 0 ? _a : size;
}
export function sortBySize(a, b) {
    var _a, _b;
    var aSize = (_a = a.meta["a-size"]) !== null && _a !== void 0 ? _a : "";
    var bSize = (_b = b.meta["a-size"]) !== null && _b !== void 0 ? _b : "";
    return SIZES.indexOf(aSize) - SIZES.indexOf(bSize);
}
//# sourceMappingURL=sizes.js.map